export const PROJECT_TYPE_OPTIONS = [
  { value: 'new_construction', label: 'New Construction' },
  { value: 'addition',         label: 'Addition' },
  { value: 'alteration',       label: 'Alteration' },
  { value: 'change_of_use',    label: 'Change of Use' },
];

export const PROJECT_PHASE_OPTIONS = [
  { value: 'pre-design',         label: 'Pre-Design' },
  { value: 'schematic',          label: 'Schematic Design' },
  { value: 'design-dev',         label: 'Design Development' },
  { value: 'construction-docs',  label: 'Construction Documents' },
  { value: 'bidding',            label: 'Bidding' },
  { value: 'construction',       label: 'Construction Admin' },
  { value: 'operating',          label: 'Operating' },
];

export const PROJECT_STATUS_OPTIONS = [
  { value: 'active',     label: 'Active' },
  { value: 'paused',     label: 'Paused' },
  { value: 'completed',  label: 'Completed' },
];

export const CONSTRUCTION_TYPE_OPTIONS = [
  { value: 'type_i',    label: 'Type I - Fire-Resistive (concrete/protected steel, 2-3hr rated)' },
  { value: 'type_ii',   label: 'Type II - Non-Combustible (steel/concrete, lower fire resistance)' },
  { value: 'type_iii',  label: 'Type III - Ordinary (noncombustible exterior, wood interior)' },
  { value: 'type_iv',   label: 'Type IV - Heavy Timber (thick wood beams/columns, 8"+ members)' },
  { value: 'type_v',    label: 'Type V - Wood Frame (light-framed wood walls and roofs)' },
];

export const TEAM_ROLE_OPTIONS = [
  { value: 'MEMBER',  label: 'Member' },
  { value: 'ADMIN',   label: 'Admin' },
];



export const BUILDING_METRIC_FIELDS = [
  {
    key: 'buildingFootprintArea',
    label: 'Building Footprint Area',
    unit: 'm²',
    placeholder: 'e.g., 600',
    type: 'decimal',
    commas: true,
  },
  {
    key: 'grossFloorArea',
    label: 'Gross Floor Area',
    unit: 'm²',
    placeholder: 'e.g., 1800',
    type: 'decimal',
    commas: true,
  },
  {
    key: 'siteArea',
    label: 'Site Area',
    unit: 'm²',
    placeholder: 'e.g., 2500',
    type: 'decimal',
    commas: true,
  },
  {
    key: 'averageGrade',
    label: 'Average Grade',
    unit: null,
    placeholder: 'e.g., 2.5',
    type: 'decimal',
    commas: false,
  },
  {
    key: 'storeysAboveGrade',
    label: 'Storeys Above Grade',
    unit: null,
    placeholder: 'e.g., 3',
    type: 'integer',
    commas: true,
  },
  {
    key: 'storeysBelowGrade',
    label: 'Storeys Below Grade',
    unit: null,
    placeholder: 'e.g., 1',
    type: 'integer',
    commas: true,
  },
  {
    key: 'adjacentStreets',
    label: 'Adjacent Streets',
    unit: null,
    placeholder: 'e.g., 2',
    type: 'integer',
    commas: true,
  },
  {
    key: 'roughConstructionBudget',
    label: 'Rough Construction Budget',
    unit: '$',
    unitPosition: 'prefix',
    placeholder: 'e.g., 1250000',
    type: 'integer',
    commas: true,
  },
];


export const PART9_MAX_STOREYS = 3;
export const PART9_MAX_FOOTPRINT = 600;
export const PART9_ALLOWED_CODES = new Set(['c', 'd', 'e', 'f2', 'f3']);

export const isPart9Canada = ({ storeysAboveGrade, buildingFootprintArea, occupancyCodes }) => {
  const storeys = parseInt(storeysAboveGrade || '', 10);
  const footprint = parseFloat(buildingFootprintArea || '');
  if (!Number.isFinite(storeys) || !Number.isFinite(footprint)) return false;
  return (
    storeys <= PART9_MAX_STOREYS &&
    footprint <= PART9_MAX_FOOTPRINT &&
    (occupancyCodes || []).some((c) => PART9_ALLOWED_CODES.has((c || '').toLowerCase()))
  );
};

export const getBuildingClassification = ({ occupancyRegion, storeysAboveGrade, buildingFootprintArea, occupancyCodes }) => {
  if (occupancyRegion !== 'CA') return 'IBC (US)';
  return isPart9Canada({ storeysAboveGrade, buildingFootprintArea, occupancyCodes })
    ? 'Part 9'
    : 'Part 3';
};


export const formatWithCommas = (value) => {
  if (value === 0) return '0';
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (s.trim() === '') return '';
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const removeCommas = (value) => (value || '').replace(/,/g, '');
export const onlyDigits  = (raw) => /^\d*$/.test(raw);
export const onlyDecimal = (raw) => /^\d*\.?\d*$/.test(raw);



export const DEFAULT_PROJECT_FORM = {
  name: '',
  description: '',
  address: '',
  zoningDesignation: '',
  type: '',
  phase: '',
  status: '',
  startDate: '',
  estimatedCompletion: '',
  occupancyRegion: 'CA',
  occupancyTypes: [],
  occupancyCodes: [],
  majorOccupancy: '',
  buildingFootprintArea: '',
  siteArea: '',
  grossFloorArea: '',
  storeysAboveGrade: '',
  storeysBelowGrade: '',
  averageGrade: '',
  adjacentStreets: '',
  roughConstructionBudget: '',
  constructionType: '',
};